import WalkthroughStep from './WalkthroughStep';

export default WalkthroughStep;
